// src/features/dashboard/hooks/useAdminDashboardData.ts
import { dashboardService } from "../services/dashboard.service";
import { useCachedDashboard } from "./useCachedDashboard";

/* ---------- Hook ---------- */

export const useAdminDashboardData = () => {
  const { data, fetchedAt, loading, refreshing, error, refresh } = useCachedDashboard("admin", () =>
    dashboardService.getDashboardData()
  );

  return {
    loading,
    refreshing,
    error,
    fetchedAt,
    refresh,
    attentionItems: data?.attentionItems ?? [],
    studentOverview: data?.studentOverview ?? null,
    feeOverview: data?.feeOverview ?? null,
    feeByGrade: data?.feeByGrade ?? [],
    dailyFeeTrend: data?.dailyFeeTrend ?? [],
    monthlyFeeTrend: data?.monthlyFeeTrend ?? [],
    attendanceByGrade: data?.studentAttendanceByGrade ?? [],
    facultyAttendance: data?.facultyAttendanceByCategory ?? [],
  };
};
